export default __webpack_public_path__ + "static/media/dashboard-programs.e0843913.jpg";